//natives
import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import md5 from 'md5';
import base64 from 'base-64';

//components
import Modal_Mini_List from '../childrens/Modal_Mini_List/.mixins/Modal_Mini_List';
import Alerta from "../../../../../../../util/snackbars/.mixins/";
import { AuthContext } from "../../../../../../../../contexts/AuthContext";

//controllers
import Config from '../../../../../../../../controllers/config';

export default class Modal_Left_Top extends Component {
    static contextType = AuthContext;

    constructor(props) {
        super(props);

        this.inputRef = React.createRef();
        this.child = React.createRef();
        this.permissions = {};

        this.state = {
            loading: true,
            itens: null,
            novo: false,
            pai: props,
            listaNovo: [],
        }
        
        this.loadData = this.loadData.bind(this);
    }
    
    componentWillMount() {
        this.permissions = this.context.user.permissions;
    }
    
    componentDidMount() {        
        this.loadData();
    }

    diff = (a,b) => {
        return a.filter((i) => {return b.indexOf(i) < 0;});
    };

    async loadData() {
        const cookies = new Cookies();
        const response = await fetch(Config.URL_BACKEND+this.props.link+'/', {
            method: 'GET',
            headers: {
                'Content-Type':'application/json',
                'User-Token': cookies.get('User-Token')
            }
        });
        const j_response = await response.json();
        if (response.status == 200) {
            if (!(cookies.get(this.props.title+'Cache') && cookies.get(this.props.title+'Cache') === md5(JSON.stringify(j_response.itens))))
                cookies.set(this.props.title+'Cache', md5(JSON.stringify(j_response.itens)), { path: '/' });

            if (cookies.get(this.props.title+'ListaCache')) {
                var listaNova = [];

                switch (this.props.message) {
                    case "contato":
                        j_response.itens.forEach(e => {
                            listaNova.push(e.ID_CONTATO);
                        });
                    break;
                    case "comunicado":
                        j_response.itens.forEach(e => {
                            listaNova.push(e.ID_CFG);
                        });
                    break;
                    case "pendencias":
                        j_response.itens.forEach(e => {
                         listaNova.push(e.NR_PEDIDO);
                        });
                    break;
                    default:
                        break;
                }

                if (cookies.get(this.props.title+'ListaCache') && 
                    this.props.message !== "pendencias") {
                    var listaAntiga = JSON.parse(base64.decode(cookies.get(this.props.title+'ListaCache')));
                    var listDif = this.diff(listaNova,listaAntiga);
                    this.setState({listaNovo: listDif});
                } else {
                    this.setState({listaNovo: listaNova});
                }
                cookies.set(this.props.title+'ListaCache', base64.encode(JSON.stringify(listaNova)), { path: '/' });
            } else {
                var listaNova = [];

                if (this.props.message == "contato") {
                    j_response.itens.forEach(e => {
                        listaNova.push(e.ID_CONTATO);
                    });
                } else {
                    j_response.itens.forEach(e => {
                        listaNova.push(e.ID_CFG);
                    });
                }

                //this.setState({listaNovo: listaNova});
                cookies.set(this.props.title+'ListaCache', base64.encode(JSON.stringify(listaNova)), { path: '/' });
            }
            this.setState({novo: this.state.listaNovo.length > 0 ? true : false})
    
            if (this.props.message == "contato") {
                var group_to_values = j_response.itens.reduce(function (obj, item) {
                    obj[item.DS_GRUPO] = obj[item.DS_GRUPO] || [];
                    obj[item.DS_GRUPO].push({
                        id: item.ID_CONTATO,
                        grupo_id: item.ID_GRUPO, 
                        descricao: item.DS_CONTATO, 
                        titulo: item.NM_TITULO, 
                        diretorio: item.DS_DIRETORIO, 
                    });
                    return obj;
                }, {});
                
                var groups = Object.keys(group_to_values).map(function (key) {
                    return {descricao: key, itens: group_to_values[key]};
                });

                j_response.itens = groups;
            }

            this.setState({
                loading: false,
                itens: j_response.itens
            });
            
        } else {
            window.location.reload();
        }
    }

    render() {
        return(
            <div>
                <Modal_Mini_List {...this}/>
                <Alerta ref={this.child}/>
            </div>
        );
    }

}